module.exports = __webpack_public_path__ + "img/logo.72d0ab8e.png";